import 'client-only';

import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { PaymentsState } from '@/atoms/payments/paymentsState';

export const useCreditCardForm = () => {
  const [creditCardForm, setCreditCardForm] = useAtom(
    PaymentsState.CreditCardFormAtom,
  );

  const setCcFormMeta = useCallback(
    (newCcFormMeta: Partial<typeof creditCardForm>) => {
      setCreditCardForm((previousCcFormMeta) => ({
        ...previousCcFormMeta,
        ...newCcFormMeta,
      }));
    },
    [setCreditCardForm],
  );

  const resetCcForm = useCallback(() => {
    setCreditCardForm(PaymentsState.InitialCreditCardFormState);
  }, [setCreditCardForm]);

  return {
    ccFormMeta: creditCardForm,
    setCcFormMeta,
    resetCcForm,
  };
};
